import React, { useEffect } from 'react';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';

export const ChatHotjarRecording = () => {
  const dynamicParameters = ParameterService.getParameters();

  useEffect(() => {
    if (dynamicParameters.HOTJAR_APP_ID && typeof window !== 'undefined') {
      try {
        // @ts-ignore
        if (window.hj) {
          // @ts-ignore
          window.hj('stateChange', 'chat_page');
          // @ts-ignore
          window.hj('tagRecording', ['chat_page']);
        }
      } catch (error) {
        console.warn('Failed to initialize Hotjar session recording:', error);
      }
    }
  }, []);

  return null;
};


